import { UnauthentifiedLayout } from '@layout';
import { LoginPage, ForgotPasswordPage, ResetPasswordPage } from '@pages';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router-dom';
import { RedirectToLogin } from '../RedirectToLogin';

export const unauthentifiedRoutes = (isLogged: boolean | null | undefined): RouteObject[] => [
    {
        element: <UnauthentifiedLayout />,
        children: [
            {
                path: '',
                element: isLogged ? <Navigate to="/members-management" replace /> : <RedirectToLogin />
            },
            {
                path: '/login',
                element: <LoginPage />
            },
            {
                path: '/forgot-password',
                element: isLogged ? <Navigate to="/" replace /> : <ForgotPasswordPage />
            },
            {
                path: '/reset-password',
                element: isLogged ? <Navigate to="/" replace /> : <ResetPasswordPage />
            },
            {
                path: '*',
                element: <Navigate to="/" replace />
            }
        ]
    }
];
